export enum TIPI_PRATICA {
  AMMINISTRATIVA = 'amministrativa',
  AUTORITA_IND_REG = 'autoritaindipendenteregolatoria',
  CIVILE = 'civile',
  LAVORO = 'lavoro',
  PARERISTICA = 'pareristica',
  PENALE = 'penale',
  TRIBUTARIO = 'tributario'
}
